import { ServerLogDto } from '~/app-modules/logger/clients/dto/server-log.dto';

@singleton()
export class ServerLoggerClient {
  /**
   *  Лог в консоль сервера строки message
   *  @description ! $fetch в проекте используется только для внутреннего api nuxt !
   *  @param serverLog - переданный лог выводится в консоль в неизменном json виде
   */
  async log(serverLog: ServerLogDto) {
    return await $fetch('/api/server-log', {
      method: 'post',
      body: serverLog,
    });
  }
}
